import { FileText, User, Clock, FileCheck, Globe, Monitor, FileType, Star, Users, Target, Calendar } from "lucide-react"
import { Input } from "../ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select"
import { Textarea } from "../ui/textarea"
import { Badge } from "../ui/badge"
import { Row, Col, Form } from '../ui/ot'
import BaseInfoFormItems from "./base_info_form_items"


const BaseInfoBlock1 = ({
    onValuesChange = () => {},
    fieldConfigs = [
        {
            name: "title",
            label: "文案標題", 
            label_icon: "", 
            label_css: "block text-sm font-medium text-gray-700 mb-1", 
            component: <></>, 
            component_type: "INPUT", 
            placeholder: "請輸入...", 
            badge: false, 
            badge_name: "", 
            label_content: "", 
            selection_selection_option_data: [], 
            order: 0, 
            disabled: false, 
            hidden: false, 
            value: "test",
        },
        {
            name: "category",
            label: "文案分類", 
            label_icon: "", 
            label_css: "block text-sm font-medium text-gray-700 mb-1", 
            component: <></>, 
            component_type: "SELECT", 
            placeholder: "選擇分類", 
            badge: false, 
            badge_name: "", 
            label_content: "", 
            selection_selection_option_data: [
                {
                    label: "行銷活動",
                    value: 1
                },
                {
                    label: "產品介紹",
                    value: 2
                },
                {
                    label: "新聞稿",
                    value: 3
                },
            ], 
            order: 2, 
            disabled: false, 
            hidden: false, 
        },
        {
            name: "number",
            label: "文案編號", 
            label_icon: "", 
            label_css: "block text-sm font-medium text-gray-700 mb-1", 
            component: <></>, 
            component_type: "INPUT", 
            placeholder: "請輸入...", 
            badge: false, 
            badge_name: "", 
            label_content: "", 
            selection_selection_option_data: [], 
            disabled: true, 
            hidden: false, 
        },
        {
            name: "staff",
            label: "建立人員", 
            label_icon: "<User />", 
            label_css: "block text-sm font-medium text-gray-700 mb-1", 
            component: <></>, 
            component_type: "INPUT", 
            placeholder: "請輸入...", 
            badge: false, 
            badge_name: "", 
            label_content: "", 
            selection_selection_option_data: [], 
            order: null, 
            disabled: true, 
            hidden: false, 
        },
        {
            name: "create_time",
            label: "建立時間", 
            label_icon: "<Clock />", 
            label_css: "block text-sm font-medium text-gray-700 mb-1", 
            component: <></>, 
            component_type: "DATEPICKER", 
            placeholder: "請選擇時間...", 
            badge: false, 
            badge_name: "", 
            label_content: "", 
            selection_selection_option_data: [], 
            order: "", 
            disabled: false, 
            hidden: false, 
        },
        {
            name: "status",
            label: "文案狀態", 
            label_icon: "<FileCheck />", 
            label_css: "block text-sm font-medium text-gray-700 mb-1", 
            component: <></>, 
            component_type: "LABEL", 
            placeholder: "請輸入...", 
            badge: true, 
            badge_name: "草稿", 
            label_content: "版本 1.0", 
            selection_selection_option_data: [], 
            order: 1, 
            disabled: false, 
            hidden: true, 
        },
    ],
    columnCount = 3, 
    fieldValues = {}, 
    formSubmitCheck = false,
    onFinish = () => {},
}) => {

    return (<>
        <BaseInfoFormItems 

            onValuesChange={(values) => {
                onValuesChange(values)
            }}
            columnCount={columnCount}
            wrapperCol={24}
            fill={true}
            gutter={[16,24]} 
            onFinish={(values) => {
                // console.log({values})
                onFinish(values)
            }}
            fieldConfigs={fieldConfigs}
            fieldValues={fieldValues}
            formSubmitCheck={formSubmitCheck}
        />
    </>)
}

export default BaseInfoBlock1;